import { takeLatest, put,call } from "redux-saga/effects"
import { onReadData, onReadDataSuccess } from "./dashboardSlice"

import { apiClient } from "api/axios"
import { teacherEndpoints } from "api/endpoints"
function* fetchDashboardData({payload:{id}}) {
  try {   
    const response = yield call(apiClient.get, teacherEndpoints.dashboard(id))
    yield put(onReadDataSuccess(response.data))
  } catch (error) {
    console.log(error)
    // Handle errors, e.g., dispatch an error action
  }
}

export function* watchTeacherDashboard() {
  yield takeLatest(onReadData.type, fetchDashboardData)
}

export default watchTeacherDashboard